import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderShield: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderShield"><Path d="M18.7129 11.2979L22.5 13.0752V16.2051C22.5 18.1522 21.2474 19.879 19.3965 20.4834L18.5 20.7764L17.6035 20.4834C15.7526 19.879 14.5 18.1522 14.5 16.2051V13.0752L18.2871 11.2979L18.5 11.1973L18.7129 11.2979Z" fill="currentColor"/><Path d="M12.5352 6H22V10.6309L18.5 8.98828L12.5 11.8047V16.2051C12.5 17.6017 12.9461 18.9199 13.7227 20H2V3H10.5352L12.5352 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderShield;
